// extracted by mini-css-extract-plugin
module.exports = {"positive":"ChangeIndicator_positive__j2CBj","negative":"ChangeIndicator_negative__1H2sb"};